var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 20.5C41 31.8218 31.8218 41 20.5 41C9.17816 41 0 31.8218 0 20.5C0 9.17816 9.17816 0 20.5 0C31.8218 0 41 9.17816 41 20.5Z",
    fill: "#FF9066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5543 16.4133C19.5743 16.154 19.7904 15.9539 20.0504 15.9539C20.3061 15.9539 20.5201 16.1476 20.5456 16.4019L20.9563 20.5094L23.9023 22.1928C24.0525 22.2787 24.1452 22.4384 24.1452 22.6115C24.1452 22.9294 23.8429 23.1603 23.5362 23.0766L19.5328 21.9848C19.3014 21.9217 19.1474 21.7032 19.1658 21.4641L19.5543 16.4133Z",
    fill: "#FF9066"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.901274,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7292 10.4804C15.4651 10.1656 14.9552 10.2861 14.8599 10.6858L13.866 14.8524C13.7883 15.178 14.0464 15.4865 14.3806 15.4676L18.6669 15.2247C19.0778 15.2014 19.2862 14.7194 19.0216 14.4041L17.9938 13.1791C18.7898 12.9071 19.634 12.765 20.5007 12.765C24.7779 12.765 28.2452 16.2323 28.2452 20.5094C28.2452 24.7866 24.7779 28.2539 20.5007 28.2539C16.2236 28.2539 12.7563 24.7866 12.7563 20.5094C12.7563 19.7914 12.8535 19.0881 13.0431 18.4122L11.2886 17.9201C11.0576 18.7436 10.9341 19.6121 10.9341 20.5094C10.9341 25.7929 15.2172 30.0761 20.5007 30.0761C25.7843 30.0761 30.0674 25.7929 30.0674 20.5094C30.0674 15.2259 25.7843 10.9428 20.5007 10.9428C19.1717 10.9428 17.9059 11.2138 16.7556 11.7036L15.7292 10.4804Z",
    fill: "#FF9066"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/PendingIcon.0c158f2dca61c1b4dea1b472136d4799.svg";
export { ForwardRef as ReactComponent };